<template>
  <div class="stats my">
    <div class="col-xs-12 col-md-3">
      <div class="profile">
        <img :src="$IMAGE(data.image)" @error="$avatarError" />
        <h3>{{ data.first_name }} {{ data.last_name }}</h3>
        <h4 v-html="$roles(data.role)"></h4>
        <p v-html="$directions(data.directions)"></p>
      </div>
      <div class="payments-data">
        <div class="counters">
          <h1>
            {{
              $formatNumber(
                (payrollCount - payoutCount).toString().replace("-", "")
              )
            }}
          </h1>
          <span v-if="payrollCount - payoutCount > 0">долг</span>
          <span v-else>авансирование</span>
          <span v-if="payrollCount - payoutCount === 0"> </span>
        </div>
        <p>
          Начислено<span> {{ $formatNumber(payrollCount) }} </span>
        </p>
        <p>
          Выдано<span>{{ $formatNumber(payoutCount) }} </span>
        </p>
      </div>
    </div>
    <div class="col-md-9 col-xs-12">
      <graph-stats
        :statsData="stats_data"
        :mobile="$mediaQuery() === 'mobile'"
        :title="stats_title"
      ></graph-stats>
      <table-stats
        :stats="stats"
        :counters="currentCounters"
        :hide-average="true"
      ></table-stats>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
    import { mapState, mapActions } from 'vuex'
    import tableStats from '@/components/finance/table-stats.vue'
    import graphStats from '@/components/finance/graph-stats.vue'
import { average, processPayoutArray } from "../../plugins/_helpers";
    
    export default {
    	components:{ tableStats, graphStats},
    	computed:{
            ...mapState('finance',['stats', 'stats_data']),
            ...mapState('user', ['data']),
            payrollCount(){
            	let result = 0 ;
	            const payroll = this.stats.map(s => s.payroll );
	            if(payroll.length) result = payroll.reduce((acc,v) => acc + (v || 0) );
	            return parseInt(result)
            },
            payoutCount(){
              let result = 0, days = 0;
              for (const stat of this.stats) {
                for (const day of stat.days) {
                  days = days + (day.payout + day.cashout + day.cardout);
                }
              }
              return parseInt(days);
            },
            calcCounters(){
              const payout = processPayoutArray(this.stats)

              this.currentCounters.payrollAverage = Math.round(
                average(
                  this.stats.map(s => Math.abs(s.payroll)).filter(item => item > 0)
                )
              );

              this.currentCounters.payoutAverage = Math.round(average(payout.filter(item => item > 0)));
              this.currentCounters.result = (this.payrollCount - this.payoutCount)
              this.currentCounters.result_str = (this.currentCounters.payroll - this.currentCounters.payout).toString().replace('-','')
            },
            lastMonth(){
              let month = null;
              try {
                const withPayroll = this.stats.filter(s => s.payroll !== 0).sort((a,b) => b.date - a.date);
                month = withPayroll.pop().month
              } catch (e){ void e }
	            return month
            }
        },
        methods:{
            ...mapActions('finance', ['getUserStats']),
        },
        async beforeMount() {
          await this.getUserStats();

        },
	    
//	    watch:{
//		    stats:{
//			    deep:true,
//			    handler(){
//
//			    	this.$nextTick(()=>this.calcCounters())
//
//			    }
//		    }
//	    },
        data(){
        	return{
		        stats_title:'Мои финансы',
		        currentCounters:{
			        payroll:0,
			        payout:0,
			        result:0,
			        result_str:0,
              payoutAverage: 0,
              payrollAverage: 0
            }
        	}
        },
        mounted() {
    	    // trigger for update table stat average values
          this.calcCounters
        }
    }
</script>